import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout, onFeedbackClick }) {
  const navigate = useNavigate();
  const [offerClosed, setOfferClosed] = useState(false);
  const now = new Date();
  const offerActive = now >= new Date('2026-07-03T00:00:00') && now <= new Date('2026-07-12T23:59:59');
  const showOffer = offerActive && !offerClosed && user && !user.isPro;

  return (
    <>
    {showOffer && (
      <div className="offer-banner">
        <span>🎉 July Offer: <strong>50% off your first month of Pro</strong> — use code <strong>JULY50</strong> at checkout. Valid till July 12.</span>
        <button className="offer-banner-cta" onClick={() => navigate('/pricing')}>Get Pro</button>
        <button className="offer-banner-close" onClick={() => setOfferClosed(true)}>×</button>
      </div>
    )}
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/logo.png" alt="LaTeXLaB" className="nav-logo" />
        </div>

        <div className="nav-links">
          <a href="/#features" className="nav-link">Features</a>
          <a href="/#templates" className="nav-link">Templates</a>

          <button
            className="btn btn-word-latex"
            onClick={() => navigate('/convert')}
          >
            Word → LaTeX
          </button>

          <a
            href="mailto:latexlab2026@gmail.com"
            className="nav-link"
          >
            Help
          </a>

          {user && !user.isPro && (
            <button
              className="btn-go-pro"
              onClick={() => navigate('/pricing')}
              style={{position: 'relative'}}
            >
              Go Pro
              {new Date() < new Date('2026-06-15T23:59:59') && (
                <span style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  background: '#ef4444',
                  color: 'white',
                  fontSize: '9px',
                  fontWeight: 'bold',
                  padding: '2px 5px',
                  borderRadius: '10px',
                  animation: 'pulse 1.5s infinite',
                  whiteSpace: 'nowrap'
                }}>25% OFF</span>
              )}
            </button>
          )}
          {user && user.isPro && (
            <a
              href="https://latexlab.lemonsqueezy.com/billing"
              target="_blank"
              rel="noreferrer"
              className="btn-pro-badge"
            >
              ✓ Pro Member
            </a>
          )}
          <button
            onClick={onFeedbackClick}
            className="btn-feedback"
          >
            💬 Feedback
          </button>

          {user ? (
            <>
              <button
                className="nav-link-btn"
                onClick={() => navigate('/editor')}
              >
                My Editor
              </button>
              <div className="nav-user-group">
                <div className="nav-user">
                  <span className="user-name">{user.name}</span>
                  <button
                    className="btn btn-logout"
                    onClick={onLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/login')}
              >
                Login
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/register')}
              >
                Sign Up Free
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
    </>
  );
}

export default Navbar;
